import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePharmacist } from '../hook/usePharmacist';

const PharmcyRoute = ({ component: Component, ...rest }) => {
  const { isPharmacist,isAdmin,isSuperAdmin, isLoading } = usePharmacist();
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (isPharmacist||isAdmin||isSuperAdmin) ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

export default PharmcyRoute;